import { SET_PAYFAC_INVOICES, UPDATE_INVOICE_AMOUNT } from '../actions/payfacActions';

const initialState = {
  invoicesToPay: []
};

const payfacReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAYFAC_INVOICES:
      return {
        ...state,
        invoicesToPay: action.payload
      };
    case UPDATE_INVOICE_AMOUNT:
      return {
        ...state,
        invoicesToPay: state.invoicesToPay.map(invoice => {
          if (invoice.uuid === action.payload.invoiceUuid) {
            return {
              ...invoice,
              amountToPay: action.payload.amountToPay
            };
          }
          return invoice;
        })
      };
    default:
      return state;
  }
};

export default payfacReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/payfacReducer.js